import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type {
  ExternalProviderRepository,
  ExternalProviderDashboardVM,
} from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface RetrieveExternalProviderDashboardQuery {
  externalProviderRepository: ExternalProviderRepository;
}

export const retrieveExternalProviderDashboard = createAsyncThunk<ExternalProviderDashboardVM, RetrieveExternalProviderDashboardQuery>(
  "externalProvider/retrieveDashboard",
  async ({ externalProviderRepository }: RetrieveExternalProviderDashboardQuery) => {
    return externalProviderRepository.getDashboard();
  },
);

export const resetRetrieveExternalProviderDashboard = createAction("externalProvider/resetRetrieveDashboard");
